import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useConsent } from './ConsentContext.js';
export function ConsentBanner(props = {}) {
    const { core, strings, dialogId } = useConsent();
    const isRTL = typeof strings?.locale === 'string' && strings.locale.toLowerCase().startsWith('ar');
    const gpc = Boolean(core.gpcActive);
    const [open, setOpen] = useState(() => {
        const s = core.getState();
        return !(s.categories.analytics || s.categories.marketing || s.categories.functional);
    });
    const firstBtn = useRef(null);
    const bannerRef = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        firstBtn.current?.focus();
        const onKey = (e) => {
            if (!open)
                return;
            if (e.key === 'Escape') {
                e.preventDefault();
                setOpen(false);
                return;
            }
            if (e.key !== 'Tab')
                return;
            const focusables = bannerRef.current?.querySelectorAll('button,a,[tabindex]:not([tabindex="-1"])');
            const arr = focusables
                ? Array.from(focusables).filter((n) => !n.hasAttribute('disabled'))
                : [];
            if (arr.length === 0)
                return;
            const first = arr[0];
            const last = arr[arr.length - 1];
            const active = document.activeElement;
            if (e.shiftKey && active === first) {
                last.focus();
                e.preventDefault();
            }
            else if (!e.shiftKey && active === last) {
                first.focus();
                e.preventDefault();
            }
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [open]);
    if (!open)
        return null;
    const dataCmp = props['data-cmp'] ?? 'cmp-banner';
    return (_jsx("div", { dir: isRTL ? 'rtl' : undefined, role: "dialog", "aria-modal": "true", "aria-labelledby": "cmp-title", "aria-describedby": "cmp-desc", ref: bannerRef, "data-cmp": dataCmp, className: props.className, style: {
            position: 'fixed',
            bottom: 16,
            left: 16,
            right: 16,
            ...(props.style ?? {}),
        }, children: _jsxs("div", { "data-cmp": "panel", style: {
                maxWidth: 800,
                margin: '0 auto',
                padding: 16,
                borderRadius: 'var(--cmp-radius, 12px)',
                boxShadow: 'var(--cmp-shadow, 0 2px 12px rgba(0,0,0,0.15))',
                background: 'var(--cmp-bg, #ffffff)',
                color: 'var(--cmp-text, inherit)',
                border: '1px solid var(--cmp-border, #e5e7eb)',
            }, children: [_jsx("h3", { id: "cmp-title", children: strings.title }), _jsx("p", { id: "cmp-desc", children: strings.description }), gpc && (_jsxs("p", { "aria-live": "polite", style: { marginTop: 6, fontSize: 12, opacity: 0.85 }, children: [_jsx("strong", { children: "GPC signal detected" }), " \u2014 non-essential cookies are off by default."] })), _jsxs("div", { style: { marginTop: 12, display: 'flex', gap: 8 }, children: [_jsx("button", { ref: firstBtn, onClick: () => {
                                core.setAll(false);
                                setOpen(false);
                            }, style: {
                                padding: '6px 10px',
                                border: '1px solid var(--cmp-btn-secondary-border, #d1d5db)',
                                borderRadius: 'var(--cmp-radius, 8px)',
                                background: 'var(--cmp-btn-secondary-bg, #fff)',
                                color: 'var(--cmp-btn-secondary-text, inherit)',
                            }, children: strings.buttons.rejectAll }), _jsx("button", { onClick: () => {
                                core.setAll(true);
                                setOpen(false);
                            }, style: {
                                padding: '6px 10px',
                                borderRadius: 'var(--cmp-radius, 8px)',
                                background: 'var(--cmp-btn-primary-bg, #000)',
                                color: 'var(--cmp-btn-primary-text, #fff)',
                            }, children: strings.buttons.acceptAll }), _jsx("button", { onClick: () => document.getElementById(dialogId)?.showModal(), style: { padding: '6px 10px', background: 'transparent', textDecoration: 'underline' }, children: strings.buttons.manage })] })] }) }));
}
//# sourceMappingURL=ConsentBanner.js.map